{
    "v": "4.8.0",
    "meta": { "g": "LottieFiles AE ", "a": "", "k": "", "d": "", "tc": "" },
    "fr": 25,
    "ip": 0,
    "op": 75,
    "w": 500,
    "h": 500,
    "nm": "Icon-37 Person focus",
    "ddd": 0,
    "assets": [
        {
            "id": "comp_0",
            "layers": [
                {
                    "ddd": 0,
                    "ind": 1,
                    "ty": 4,
                    "nm": "Isolation Mode 4",
                    "sr": 1,
                    "ks": {
                        "o": { "a": 0, "k": 100, "ix": 11 },
                        "r": { "a": 0, "k": 0, "ix": 10 },
                        "p": { "a": 0, "k": [310, 310, 0], "ix": 2 },
                        "a": { "a": 0, "k": [0, 0, 0], "ix": 1 },
                        "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [0, 0],
                                                [0, 0]
                                            ],
                                            "o": [
                                                [0, 0],
                                                [0, 0]
                                            ],
                                            "v": [
                                                [-164.18, -164.18],
                                                [-106.066, -106.066]
                                            ],
                                            "c": false
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": { "a": 0, "k": [0, 0, 0, 1], "ix": 3 },
                                    "o": { "a": 0, "k": 100, "ix": 4 },
                                    "w": {
                                        "a": 0,
                                        "k": 21,
                                        "ix": 5,
                                        "x": "var $bm_rt;\n$bm_rt = $bm_div(comp('Icon-37 Person focus').layer('Stroke width - color Ctrl ').effect('Stroke width')('Slider'), 0.8);"
                                    },
                                    "lc": 2,
                                    "lj": 2,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": { "a": 0, "k": [0, 0], "ix": 2 },
                                    "a": { "a": 0, "k": [0, 0], "ix": 1 },
                                    "s": { "a": 0, "k": [100, 100], "ix": 3 },
                                    "r": { "a": 0, "k": 0, "ix": 6 },
                                    "o": { "a": 0, "k": 100, "ix": 7 },
                                    "sk": { "a": 0, "k": 0, "ix": 4 },
                                    "sa": { "a": 0, "k": 0, "ix": 5 },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Group 1",
                            "np": 2,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        },
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [0, -24.853],
                                                [24.853, 0],
                                                [0, 24.853],
                                                [-24.853, 0]
                                            ],
                                            "o": [
                                                [0, 24.853],
                                                [-24.853, 0],
                                                [0, -24.853],
                                                [24.853, 0]
                                            ],
                                            "v": [
                                                [-151, -196],
                                                [-196, -151],
                                                [-241, -196],
                                                [-196, -241]
                                            ],
                                            "c": true
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": { "a": 0, "k": [0, 0, 0, 1], "ix": 3 },
                                    "o": { "a": 0, "k": 100, "ix": 4 },
                                    "w": {
                                        "a": 0,
                                        "k": 21,
                                        "ix": 5,
                                        "x": "var $bm_rt;\n$bm_rt = $bm_div(comp('Icon-37 Person focus').layer('Stroke width - color Ctrl ').effect('Stroke width')('Slider'), 0.8);"
                                    },
                                    "lc": 2,
                                    "lj": 2,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": { "a": 0, "k": [0, 0], "ix": 2 },
                                    "a": { "a": 0, "k": [0, 0], "ix": 1 },
                                    "s": { "a": 0, "k": [100, 100], "ix": 3 },
                                    "r": { "a": 0, "k": 0, "ix": 6 },
                                    "o": { "a": 0, "k": 100, "ix": 7 },
                                    "sk": { "a": 0, "k": 0, "ix": 4 },
                                    "sa": { "a": 0, "k": 0, "ix": 5 },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Group 2",
                            "np": 2,
                            "cix": 2,
                            "bm": 0,
                            "ix": 2,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 0,
                    "op": 75,
                    "st": 0,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 2,
                    "ty": 4,
                    "nm": "Isolation Mode 3",
                    "sr": 1,
                    "ks": {
                        "o": { "a": 0, "k": 100, "ix": 11 },
                        "r": { "a": 0, "k": 0, "ix": 10 },
                        "p": { "a": 0, "k": [310, 310, 0], "ix": 2 },
                        "a": { "a": 0, "k": [0, 0, 0], "ix": 1 },
                        "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [0, 0],
                                                [0, 0]
                                            ],
                                            "o": [
                                                [0, 0],
                                                [0, 0]
                                            ],
                                            "v": [
                                                [-164.18, 164.18],
                                                [-106.066, 106.066]
                                            ],
                                            "c": false
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": { "a": 0, "k": [0, 0, 0, 1], "ix": 3 },
                                    "o": { "a": 0, "k": 100, "ix": 4 },
                                    "w": {
                                        "a": 0,
                                        "k": 21,
                                        "ix": 5,
                                        "x": "var $bm_rt;\n$bm_rt = $bm_div(comp('Icon-37 Person focus').layer('Stroke width - color Ctrl ').effect('Stroke width')('Slider'), 0.8);"
                                    },
                                    "lc": 2,
                                    "lj": 2,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": { "a": 0, "k": [0, 0], "ix": 2 },
                                    "a": { "a": 0, "k": [0, 0], "ix": 1 },
                                    "s": { "a": 0, "k": [100, 100], "ix": 3 },
                                    "r": { "a": 0, "k": 0, "ix": 6 },
                                    "o": { "a": 0, "k": 100, "ix": 7 },
                                    "sk": { "a": 0, "k": 0, "ix": 4 },
                                    "sa": { "a": 0, "k": 0, "ix": 5 },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Group 1",
                            "np": 2,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        },
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [0, -24.853],
                                                [24.853, 0],
                                                [0, 24.853],
                                                [-24.853, 0]
                                            ],
                                            "o": [
                                                [0, 24.853],
                                                [-24.853, 0],
                                                [0, -24.853],
                                                [24.853, 0]
                                            ],
                                            "v": [
                                                [-151, 196],
                                                [-196, 241],
                                                [-241, 196],
                                                [-196, 151]
                                            ],
                                            "c": true
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": { "a": 0, "k": [0, 0, 0, 1], "ix": 3 },
                                    "o": { "a": 0, "k": 100, "ix": 4 },
                                    "w": {
                                        "a": 0,
                                        "k": 21,
                                        "ix": 5,
                                        "x": "var $bm_rt;\n$bm_rt = $bm_div(comp('Icon-37 Person focus').layer('Stroke width - color Ctrl ').effect('Stroke width')('Slider'), 0.8);"
                                    },
                                    "lc": 2,
                                    "lj": 2,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": { "a": 0, "k": [0, 0], "ix": 2 },
                                    "a": { "a": 0, "k": [0, 0], "ix": 1 },
                                    "s": { "a": 0, "k": [100, 100], "ix": 3 },
                                    "r": { "a": 0, "k": 0, "ix": 6 },
                                    "o": { "a": 0, "k": 100, "ix": 7 },
                                    "sk": { "a": 0, "k": 0, "ix": 4 },
                                    "sa": { "a": 0, "k": 0, "ix": 5 },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Group 2",
                            "np": 2,
                            "cix": 2,
                            "bm": 0,
                            "ix": 2,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 0,
                    "op": 75,
                    "st": 0,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 3,
                    "ty": 4,
                    "nm": "Isolation Mode 2",
                    "sr": 1,
                    "ks": {
                        "o": { "a": 0, "k": 100, "ix": 11 },
                        "r": { "a": 0, "k": 0, "ix": 10 },
                        "p": { "a": 0, "k": [310, 310, 0], "ix": 2 },
                        "a": { "a": 0, "k": [0, 0, 0], "ix": 1 },
                        "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [0, 0],
                                                [0, 0]
                                            ],
                                            "o": [
                                                [0, 0],
                                                [0, 0]
                                            ],
                                            "v": [
                                                [106.066, 106.066],
                                                [164.18, 164.18]
                                            ],
                                            "c": false
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": { "a": 0, "k": [0, 0, 0, 1], "ix": 3 },
                                    "o": { "a": 0, "k": 100, "ix": 4 },
                                    "w": {
                                        "a": 0,
                                        "k": 21,
                                        "ix": 5,
                                        "x": "var $bm_rt;\n$bm_rt = $bm_div(comp('Icon-37 Person focus').layer('Stroke width - color Ctrl ').effect('Stroke width')('Slider'), 0.8);"
                                    },
                                    "lc": 2,
                                    "lj": 2,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": { "a": 0, "k": [0, 0], "ix": 2 },
                                    "a": { "a": 0, "k": [0, 0], "ix": 1 },
                                    "s": { "a": 0, "k": [100, 100], "ix": 3 },
                                    "r": { "a": 0, "k": 0, "ix": 6 },
                                    "o": { "a": 0, "k": 100, "ix": 7 },
                                    "sk": { "a": 0, "k": 0, "ix": 4 },
                                    "sa": { "a": 0, "k": 0, "ix": 5 },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Group 1",
                            "np": 2,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        },
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [0, -24.853],
                                                [24.853, 0],
                                                [0, 24.853],
                                                [-24.853, 0]
                                            ],
                                            "o": [
                                                [0, 24.853],
                                                [-24.853, 0],
                                                [0, -24.853],
                                                [24.853, 0]
                                            ],
                                            "v": [
                                                [241, 196],
                                                [196, 241],
                                                [151, 196],
                                                [196, 151]
                                            ],
                                            "c": true
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": { "a": 0, "k": [0, 0, 0, 1], "ix": 3 },
                                    "o": { "a": 0, "k": 100, "ix": 4 },
                                    "w": {
                                        "a": 0,
                                        "k": 21,
                                        "ix": 5,
                                        "x": "var $bm_rt;\n$bm_rt = $bm_div(comp('Icon-37 Person focus').layer('Stroke width - color Ctrl ').effect('Stroke width')('Slider'), 0.8);"
                                    },
                                    "lc": 2,
                                    "lj": 2,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": { "a": 0, "k": [0, 0], "ix": 2 },
                                    "a": { "a": 0, "k": [0, 0], "ix": 1 },
                                    "s": { "a": 0, "k": [100, 100], "ix": 3 },
                                    "r": { "a": 0, "k": 0, "ix": 6 },
                                    "o": { "a": 0, "k": 100, "ix": 7 },
                                    "sk": { "a": 0, "k": 0, "ix": 4 },
                                    "sa": { "a": 0, "k": 0, "ix": 5 },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Group 2",
                            "np": 2,
                            "cix": 2,
                            "bm": 0,
                            "ix": 2,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 0,
                    "op": 75,
                    "st": 0,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 4,
                    "ty": 4,
                    "nm": "Isolation Mode",
                    "sr": 1,
                    "ks": {
                        "o": { "a": 0, "k": 100, "ix": 11 },
                        "r": { "a": 0, "k": 0, "ix": 10 },
                        "p": { "a": 0, "k": [310, 310, 0], "ix": 2 },
                        "a": { "a": 0, "k": [0, 0, 0], "ix": 1 },
                        "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [0, 0],
                                                [0, 0]
                                            ],
                                            "o": [
                                                [0, 0],
                                                [0, 0]
                                            ],
                                            "v": [
                                                [106.066, -106.066],
                                                [164.18, -164.18]
                                            ],
                                            "c": false
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": { "a": 0, "k": [0, 0, 0, 1], "ix": 3 },
                                    "o": { "a": 0, "k": 100, "ix": 4 },
                                    "w": {
                                        "a": 0,
                                        "k": 21,
                                        "ix": 5,
                                        "x": "var $bm_rt;\n$bm_rt = $bm_div(comp('Icon-37 Person focus').layer('Stroke width - color Ctrl ').effect('Stroke width')('Slider'), 0.8);"
                                    },
                                    "lc": 2,
                                    "lj": 2,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": { "a": 0, "k": [0, 0], "ix": 2 },
                                    "a": { "a": 0, "k": [0, 0], "ix": 1 },
                                    "s": { "a": 0, "k": [100, 100], "ix": 3 },
                                    "r": { "a": 0, "k": 0, "ix": 6 },
                                    "o": { "a": 0, "k": 100, "ix": 7 },
                                    "sk": { "a": 0, "k": 0, "ix": 4 },
                                    "sa": { "a": 0, "k": 0, "ix": 5 },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Group 1",
                            "np": 2,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        },
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [0, -24.853],
                                                [24.853, 0],
                                                [0, 24.853],
                                                [-24.853, 0]
                                            ],
                                            "o": [
                                                [0, 24.853],
                                                [-24.853, 0],
                                                [0, -24.853],
                                                [24.853, 0]
                                            ],
                                            "v": [
                                                [241, -196],
                                                [196, -151],
                                                [151, -196],
                                                [196, -241]
                                            ],
                                            "c": true
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": { "a": 0, "k": [0, 0, 0, 1], "ix": 3 },
                                    "o": { "a": 0, "k": 100, "ix": 4 },
                                    "w": {
                                        "a": 0,
                                        "k": 21,
                                        "ix": 5,
                                        "x": "var $bm_rt;\n$bm_rt = $bm_div(comp('Icon-37 Person focus').layer('Stroke width - color Ctrl ').effect('Stroke width')('Slider'), 0.8);"
                                    },
                                    "lc": 2,
                                    "lj": 2,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": { "a": 0, "k": [0, 0], "ix": 2 },
                                    "a": { "a": 0, "k": [0, 0], "ix": 1 },
                                    "s": { "a": 0, "k": [100, 100], "ix": 3 },
                                    "r": { "a": 0, "k": 0, "ix": 6 },
                                    "o": { "a": 0, "k": 100, "ix": 7 },
                                    "sk": { "a": 0, "k": 0, "ix": 4 },
                                    "sa": { "a": 0, "k": 0, "ix": 5 },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Group 2",
                            "np": 2,
                            "cix": 2,
                            "bm": 0,
                            "ix": 2,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 0,
                    "op": 75,
                    "st": 0,
                    "bm": 0
                }
            ]
        }
    ],
    "layers": [
        {
            "ddd": 0,
            "ind": 1,
            "ty": 3,
            "nm": "Stroke width - color Ctrl ",
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 0, "ix": 11 },
                "r": { "a": 0, "k": 0, "ix": 10 },
                "p": { "a": 0, "k": [248, 248, 0], "ix": 2 },
                "a": { "a": 0, "k": [48, 48, 0], "ix": 1 },
                "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
            },
            "ao": 0,
            "ef": [
                {
                    "ty": 5,
                    "nm": "Stroke width",
                    "np": 3,
                    "mn": "ADBE Slider Control",
                    "ix": 1,
                    "en": 1,
                    "ef": [
                        {
                            "ty": 0,
                            "nm": "Slider",
                            "mn": "ADBE Slider Control-0001",
                            "ix": 1,
                            "v": { "a": 0, "k": 16, "ix": 1 }
                        }
                    ]
                },
                {
                    "ty": 5,
                    "nm": "Highlight",
                    "np": 3,
                    "mn": "ADBE Color Control",
                    "ix": 2,
                    "en": 1,
                    "ef": [
                        {
                            "ty": 2,
                            "nm": "Color",
                            "mn": "ADBE Color Control-0001",
                            "ix": 1,
                            "v": { "a": 0, "k": [0.200000017881, 0.800000071526, 0.800000071526, 1], "ix": 1 }
                        }
                    ]
                },
                {
                    "ty": 5,
                    "nm": "Base color",
                    "np": 3,
                    "mn": "ADBE Color Control",
                    "ix": 3,
                    "en": 1,
                    "ef": [
                        {
                            "ty": 2,
                            "nm": "Color",
                            "mn": "ADBE Color Control-0001",
                            "ix": 1,
                            "v": { "a": 0, "k": [0, 0, 0, 1], "ix": 1 }
                        }
                    ]
                }
            ],
            "ip": 0,
            "op": 75,
            "st": 0,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 2,
            "ty": 4,
            "nm": "Main circle",
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 100, "ix": 11 },
                "r": {
                    "a": 1,
                    "k": [
                        { "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.167], "y": [0.167] }, "t": 8, "s": [0] },
                        { "t": 67, "s": [161] }
                    ],
                    "ix": 10
                },
                "p": { "a": 0, "k": [250, 250, 0], "ix": 2 },
                "a": { "a": 0, "k": [0, 0, 0], "ix": 1 },
                "s": { "a": 0, "k": [80, 80, 100], "ix": 6 }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [0, -82.843],
                                        [82.843, 0],
                                        [0, 82.843],
                                        [-82.843, 0]
                                    ],
                                    "o": [
                                        [0, 82.843],
                                        [-82.843, 0],
                                        [0, -82.843],
                                        [82.843, 0]
                                    ],
                                    "v": [
                                        [150, 0],
                                        [0, 150],
                                        [-150, 0],
                                        [0, -150]
                                    ],
                                    "c": true
                                },
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "tm",
                            "s": {
                                "a": 1,
                                "k": [
                                    {
                                        "i": { "x": [0.77], "y": [1] },
                                        "o": { "x": [0.23], "y": [0] },
                                        "t": 27,
                                        "s": [0]
                                    },
                                    { "t": 61, "s": [100] }
                                ],
                                "ix": 1
                            },
                            "e": {
                                "a": 1,
                                "k": [
                                    {
                                        "i": { "x": [0.77], "y": [1] },
                                        "o": { "x": [0.23], "y": [0] },
                                        "t": 12,
                                        "s": [0]
                                    },
                                    { "t": 50, "s": [100] }
                                ],
                                "ix": 2
                            },
                            "o": { "a": 0, "k": 0, "ix": 3 },
                            "m": 1,
                            "ix": 2,
                            "nm": "Trim Paths 1",
                            "mn": "ADBE Vector Filter - Trim",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": { "a": 0, "k": [0.239, 0.463, 0.996, 1], "ix": 3 },
                            "o": { "a": 0, "k": 100, "ix": 4 },
                            "w": {
                                "a": 0,
                                "k": 21,
                                "ix": 5,
                                "x": "var $bm_rt;\n$bm_rt = $bm_div(thisComp.layer('Stroke width - color Ctrl ').effect('Stroke width')('Slider'), 0.8);"
                            },
                            "lc": 2,
                            "lj": 2,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [0, 0], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 1",
                    "np": 3,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false
                }
            ],
            "ip": 0,
            "op": 75,
            "st": 0,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 3,
            "ty": 4,
            "nm": "user",
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 100, "ix": 11 },
                "r": { "a": 0, "k": 0, "ix": 10 },
                "p": { "a": 0, "k": [250, 250, 0], "ix": 2 },
                "a": { "a": 0, "k": [0, 0, 0], "ix": 1 },
                "s": { "a": 0, "k": [80, 80, 100], "ix": 6 }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [0, -82.843],
                                        [82.843, 0],
                                        [0, 82.843],
                                        [-82.843, 0]
                                    ],
                                    "o": [
                                        [0, 82.843],
                                        [-82.843, 0],
                                        [0, -82.843],
                                        [82.843, 0]
                                    ],
                                    "v": [
                                        [150, 0],
                                        [0, 150],
                                        [-150, 0],
                                        [0, -150]
                                    ],
                                    "c": true
                                },
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": { "a": 0, "k": [0, 0, 0, 1], "ix": 3 },
                            "o": { "a": 0, "k": 100, "ix": 4 },
                            "w": {
                                "a": 0,
                                "k": 20,
                                "ix": 5,
                                "x": "var $bm_rt;\n$bm_rt = $bm_div(thisComp.layer('Stroke width - color Ctrl ').effect('Stroke width')('Slider'), 0.8);"
                            },
                            "lc": 2,
                            "lj": 2,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [0, 0], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 1",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [24.814, 0],
                                                [0, 24.814],
                                                [-24.814, 0],
                                                [0, -24.814]
                                            ],
                                            "o": [
                                                [-24.814, 0],
                                                [0, -24.814],
                                                [24.814, 0],
                                                [0, 24.814]
                                            ],
                                            "v": [
                                                [0, 0],
                                                [-45, -45],
                                                [0, -90],
                                                [45, -45]
                                            ],
                                            "c": true
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": { "a": 0, "k": [0, 0, 0, 1], "ix": 3 },
                                    "o": { "a": 0, "k": 100, "ix": 4 },
                                    "w": {
                                        "a": 0,
                                        "k": 21,
                                        "ix": 5,
                                        "x": "var $bm_rt;\n$bm_rt = $bm_div(thisComp.layer('Stroke width - color Ctrl ').effect('Stroke width')('Slider'), 0.8);"
                                    },
                                    "lc": 2,
                                    "lj": 2,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 1,
                                        "k": [
                                            {
                                                "i": { "x": 0.79, "y": 1 },
                                                "o": { "x": 0.21, "y": 0 },
                                                "t": 19,
                                                "s": [0, 12],
                                                "to": [-3.333, 0],
                                                "ti": [0, 0]
                                            },
                                            {
                                                "i": { "x": 0.79, "y": 1 },
                                                "o": { "x": 0.21, "y": 0 },
                                                "t": 34,
                                                "s": [-20, 12],
                                                "to": [0, 0],
                                                "ti": [-7.077, 7.077]
                                            },
                                            {
                                                "i": { "x": 0.79, "y": 1 },
                                                "o": { "x": 0.21, "y": 0 },
                                                "t": 44,
                                                "s": [11.646, 12],
                                                "to": [6.729, -6.729],
                                                "ti": [-2.437, 2.437]
                                            },
                                            { "t": 58, "s": [0, 12] }
                                        ],
                                        "ix": 2
                                    },
                                    "a": { "a": 0, "k": [0, 0], "ix": 1 },
                                    "s": { "a": 0, "k": [100, 100], "ix": 3 },
                                    "r": { "a": 0, "k": 0, "ix": 6 },
                                    "o": { "a": 0, "k": 100, "ix": 7 },
                                    "sk": { "a": 0, "k": 0, "ix": 4 },
                                    "sa": { "a": 0, "k": 0, "ix": 5 },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Group 1",
                            "np": 2,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        },
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [0, 0],
                                                [0, 0],
                                                [-41.421, 0],
                                                [0, -41.421],
                                                [0, 0]
                                            ],
                                            "o": [
                                                [0, 0],
                                                [0, -41.421],
                                                [41.421, 0],
                                                [0, 0],
                                                [0, 0]
                                            ],
                                            "v": [
                                                [-75, 129.933],
                                                [-75, 105],
                                                [0, 30],
                                                [75, 105],
                                                [75, 129.933]
                                            ],
                                            "c": false
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": { "a": 0, "k": [0, 0, 0, 1], "ix": 3 },
                                    "o": { "a": 0, "k": 100, "ix": 4 },
                                    "w": {
                                        "a": 0,
                                        "k": 21,
                                        "ix": 5,
                                        "x": "var $bm_rt;\n$bm_rt = $bm_div(thisComp.layer('Stroke width - color Ctrl ').effect('Stroke width')('Slider'), 0.8);"
                                    },
                                    "lc": 2,
                                    "lj": 2,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": { "a": 0, "k": [0, 0], "ix": 2 },
                                    "a": { "a": 0, "k": [0, 0], "ix": 1 },
                                    "s": { "a": 0, "k": [100, 100], "ix": 3 },
                                    "r": { "a": 0, "k": 0, "ix": 6 },
                                    "o": { "a": 0, "k": 100, "ix": 7 },
                                    "sk": { "a": 0, "k": 0, "ix": 4 },
                                    "sa": { "a": 0, "k": 0, "ix": 5 },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Group 2",
                            "np": 2,
                            "cix": 2,
                            "bm": 0,
                            "ix": 2,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [0, 0], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Population",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 2,
                    "mn": "ADBE Vector Group",
                    "hd": false
                }
            ],
            "ip": 0,
            "op": 75,
            "st": 0,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 4,
            "ty": 4,
            "nm": "Circle mask",
            "parent": 2,
            "td": 1,
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 100, "ix": 11 },
                "r": { "a": 0, "k": -30.017, "ix": 10 },
                "p": { "a": 0, "k": [0, 0, 0], "ix": 2 },
                "a": { "a": 0, "k": [0, 0, 0], "ix": 1 },
                "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [0, -82.843],
                                        [82.843, 0],
                                        [0, 82.843],
                                        [-82.843, 0]
                                    ],
                                    "o": [
                                        [0, 82.843],
                                        [-82.843, 0],
                                        [0, -82.843],
                                        [82.843, 0]
                                    ],
                                    "v": [
                                        [150, 0],
                                        [0, 150],
                                        [-150, 0],
                                        [0, -150]
                                    ],
                                    "c": true
                                },
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "tm",
                            "s": { "a": 0, "k": 0, "ix": 1 },
                            "e": { "a": 0, "k": 100, "ix": 2 },
                            "o": { "a": 0, "k": 0, "ix": 3 },
                            "m": 1,
                            "ix": 2,
                            "nm": "Trim Paths 1",
                            "mn": "ADBE Vector Filter - Trim",
                            "hd": false
                        },
                        {
                            "ty": "fl",
                            "c": { "a": 0, "k": [1, 0, 0, 1], "ix": 4 },
                            "o": { "a": 0, "k": 100, "ix": 5 },
                            "r": 1,
                            "bm": 0,
                            "nm": "Fill 1",
                            "mn": "ADBE Vector Graphic - Fill",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": { "a": 0, "k": [0.239, 0.463, 0.996, 1], "ix": 3 },
                            "o": { "a": 0, "k": 100, "ix": 4 },
                            "w": {
                                "a": 0,
                                "k": 21,
                                "ix": 5,
                                "x": "var $bm_rt;\n$bm_rt = $bm_div(thisComp.layer('Stroke width - color Ctrl ').effect('Stroke width')('Slider'), 0.8);"
                            },
                            "lc": 2,
                            "lj": 2,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [0, 0], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 1",
                    "np": 4,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false
                }
            ],
            "ip": 0,
            "op": 75,
            "st": 0,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 5,
            "ty": 0,
            "nm": "pins",
            "tt": 2,
            "refId": "comp_0",
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 100, "ix": 11 },
                "r": {
                    "a": 1,
                    "k": [
                        { "i": { "x": [0.47], "y": [1] }, "o": { "x": [0.53], "y": [0] }, "t": 8, "s": [0] },
                        { "t": 67, "s": [180] }
                    ],
                    "ix": 10
                },
                "p": { "a": 0, "k": [250, 250, 0], "ix": 2 },
                "a": { "a": 0, "k": [310, 310, 0], "ix": 1 },
                "s": {
                    "a": 1,
                    "k": [
                        {
                            "i": { "x": [0.47, 0.47, 0.47], "y": [1, 1, 1] },
                            "o": { "x": [0.53, 0.53, 0.53], "y": [0, 0, 0] },
                            "t": 8,
                            "s": [80, 80, 100]
                        },
                        {
                            "i": { "x": [0.47, 0.47, 0.47], "y": [1, 1, 1] },
                            "o": { "x": [0.53, 0.53, 0.53], "y": [0, 0, 0] },
                            "t": 31,
                            "s": [68, 68, 100]
                        },
                        {
                            "i": { "x": [0.47, 0.47, 0.47], "y": [1, 1, 1] },
                            "o": { "x": [0.53, 0.53, 0.53], "y": [0, 0, 0] },
                            "t": 36,
                            "s": [68, 68, 100]
                        },
                        { "t": 67, "s": [80, 80, 100] }
                    ],
                    "ix": 6
                }
            },
            "ao": 0,
            "w": 620,
            "h": 620,
            "ip": 0,
            "op": 75,
            "st": 0,
            "bm": 0
        }
    ],
    "markers": []
}
